import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

import styles from "../../../layout/admin/Main.module.scss";
/*コンポーネント */
import Completion from "./Completion";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import Select from "../../../ui/Select";
import RadioGroup from "../../../ui/RadioGroup";
import Annotation from "../../../ui/Annotation";
import Button from "../../../ui/Button";
/*バリデーション*/
import {
  validateRequired,
  validateMaxlength,
  validateMinlength,
  validateEmailAddress,
  validateConfirmMail,
  validateConfirmPassword,
  validateHalfAlphaNum,
} from "../../../../utils/validate";
/*API */
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  postAddAdmin,
  postUpdateAdmin,
  getAdminUser,
  postIsValidPassword,
} from "../../../../services/apiAdmin";

const AdminUserRegister = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  //定数；画面モード
  const displayTypeNew = "new"; //画面モード_新規
  const displayTypeUpdate = "update"; //画面モード_更新
  //URLパラメータ
  const { mode: displaytype } = useParams();
  const { id: userId } = useParams();
  const [isConfirmation, setIsConfirmation] = useState(false);
  //定数；区分ID
  const codeAuthority = "CD001";
  //区分データ
  const [authorityElements, setAuthorityElements] = useState([]); //権限ID
  //ラジオボタン選択値
  const [selectedIsMail, setSelectedIsMail] = useState(true);
  const [selectedIsRejection, setSelectedIsRejection] = useState(false);
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  const onSubmit = async (formData) => {
    const postData = {
      name: formData.name,
      mail: formData.mail1,
      password: formData.password1,
      authority: formData.authority,
      university_id: formData.university_id,
      is_email: formData.is_email,
      is_rejection: formData.is_rejection,
      updated_at: formData.updated_at,
    };
    if (!isConfirmation) {
      if (Number(userId)) {
        // 問題ないパスワードか(確認画面があるのでここでチェック)
        const is_valid_result = await postIsValidPassword(userId, postData);
        if (is_valid_result.is_valid) {
          setIsConfirmation(true);
          scrollTop();
        } else {
          // エラーメッセージ
          setError(is_valid_result.name, { message: is_valid_result.msg });
          return;
        }
      } else {
        setIsConfirmation(true);
        scrollTop();
      }
    }
    if (isConfirmation) {
      let result = null;
      if (displaytype === displayTypeNew) {
        result = await postAddAdmin(postData);
      } else if (displaytype === displayTypeUpdate) {
        result = await postUpdateAdmin(userId, postData);
      }
      // 結果返却後
      if (result) {
        setIsCompFlg(true);
        scrollTop();
      }
    }
  };

  //初回レンダリング
  useEffect(() => {
    const mapCodeFuncSelect = (d) => {
      return {
        text: d.d_text,
        value: d.d_value,
      };
    };
    (async function () {
      //区分値取得
      const auData = await getCodeMasterList({ code: codeAuthority });
      setAuthorityElements(auData.map(mapCodeFuncSelect));

      if (displaytype === displayTypeUpdate) {
        const Data = await getAdminUser(userId);
        if (Object.keys(Data).length === 0) {
          navigate("/admin/404");
          return;
        }
        setValue("updated_at", Data.updated_at);
        setValue("login_id", Data.login_id);
        setValue("name", Data.name);
        setValue("mail1", Data.email);
        setValue("mail2", Data.email);
        setValue("authority", Data.authority);
        setValue("university_id", Data.university_id);
        setValue("is_rejection", Data.is_rejection);
        setSelectedIsRejection(Data.is_rejection);
        setValue("is_email", Data.is_email);
        setSelectedIsMail(Data.is_email);
      } else {
      }
    })();
  }, []); //初回レンダリング

  const handleBack = (e) => {
    if (isConfirmation) {
      setIsConfirmation(false);
      scrollTop();
    } else {
      e.preventDefault();
      navigate(-1);
    }
  };

  return (
    <>
      {isCompFlg ? (
        <Completion
          subtitle={
            //TODO 文言の確認（設計書上は分岐なし）
            displaytype === displayTypeNew
              ? "管理ユーザー登録完了"
              : "管理ユーザー登録完了"
          }
          explanation={
            displaytype === displayTypeNew
              ? "管理ユーザーの登録が完了いたしました。"
              : "管理ユーザーの登録が完了いたしました。"
          }
          link={"/admin/admin"}
          btntext="一覧へ戻る"
        ></Completion>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>管理ユーザー管理</ScreenTitle>
          <SubScreenTitle>
            {displaytype === displayTypeNew
              ? "新規管理ユーザー登録"
              : "管理ユーザー変更"}
          </SubScreenTitle>
          {isConfirmation ? (
            <Explanation>
              入力内容をご確認の上、登録ボタンを押してください。
            </Explanation>
          ) : (
            <Explanation>
              必要事項をご入力の上、確認ボタンを押してください。
            </Explanation>
          )}
          <Form onSubmitHandler={handleSubmit(onSubmit)} autoComplete="off">
            <table className={styles.input_form_table}>
              <TextField
                type="hidden"
                name="updated_at"
                errors={errors}
                register={register}
              ></TextField>
              {displaytype === displayTypeUpdate ? (
                <tr>
                  <TextField
                    errors={errors}
                    register={register}
                    label="管理者ID"
                    name="login_id"
                    isStatic={true}
                  />
                </tr>
              ) : (
                <></>
              )}
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(30),
                  }}
                  required={true}
                  label="名前"
                  placeholder="名前"
                  name="name"
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <TextField
                  type="email"
                  errors={errors}
                  register={register}
                  required={true}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(100),
                    ...validateEmailAddress(),
                  }}
                  label="メールアドレス"
                  placeholder="メールアドレス"
                  name="mail1"
                  isStatic={isConfirmation}
                />
              </tr>
              {isConfirmation ? (
                <></>
              ) : (
                <>
                  <tr>
                    <Annotation>{"(確認用)"}</Annotation>
                  </tr>
                  <tr>
                    <TextField
                      type="email"
                      errors={errors}
                      register={register}
                      validation={{
                        ...validateConfirmMail(),
                      }}
                      name="mail2"
                      placeholder="メールアドレス(確認用)"
                    />
                  </tr>
                </>
              )}
              <tr>
                <TextField
                  type="password"
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateHalfAlphaNum(),
                    ...validateMinlength(8),
                    ...validateMaxlength(12),
                  }}
                  label="パスワード"
                  placeholder="パスワード"
                  name="password1"
                  isStatic={isConfirmation}
                  required={true}
                />
              </tr>
              {isConfirmation ? (
                <></>
              ) : (
                <>
                  <tr>
                    <Annotation>{"(確認用)"}</Annotation>
                  </tr>
                  <tr>
                    <TextField
                      type="password"
                      errors={errors}
                      register={register}
                      validation={{
                        ...validateConfirmPassword(),
                      }}
                      name="password2"
                      placeholder="パスワード(確認用)"
                    />
                  </tr>
                </>
              )}
              <tr>
                <Select
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  label="管理者権限"
                  name="authority"
                  errors={errors}
                  options={authorityElements}
                  watch={watch}
                  required={true}
                  defalut={{ text: "---選択していません---", value: "" }}
                  isSetdefalut={true}
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <TextField
                  errors={errors}
                  register={register}
                  validation={{
                    ...validateHalfAlphaNum(),
                    ...validateMaxlength(30),
                  }}
                  label="大学ID"
                  placeholder="大学ID"
                  name="university_id"
                  isStatic={isConfirmation}
                />
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="ログイン拒否"
                  name="is_rejection"
                  validation={{
                    ...validateRequired(),
                  }}
                  elements={[
                    { label: "ログイン可", value: false, defaultChecked: true },
                    { label: "ログイン不可", value: true },
                  ]}
                  watch={watch}
                  isStatic={isConfirmation}
                  selectedValue={selectedIsRejection}
                  setSelectedValue={setSelectedIsRejection}
                />
              </tr>
              <tr>
                <RadioGroup
                  errors={errors}
                  register={register}
                  label="登録変更メール配信"
                  name="is_email"
                  validation={{
                    ...validateRequired(),
                  }}
                  elements={[
                    { label: "配信する", value: true, defaultChecked: true },
                    { label: "配信しない", value: false },
                  ]}
                  watch={watch}
                  isStatic={isConfirmation}
                  selectedValue={selectedIsMail}
                  setSelectedValue={setSelectedIsMail}
                />
              </tr>
            </table>
            <div className={styles.buttonbox}>
              <Button type="button" onClick={handleBack} styleType="back">
                {isConfirmation ? "変更ページへ戻る" : "一覧へ戻る"}
              </Button>
              <Button type="submit" styleType="register">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
            {!isConfirmation && (
              <div className={styles.buttonbox}>
                <Link className={styles.link} to="../../top">
                  トップページへ戻る
                </Link>
              </div>
            )}
          </Form>
        </div>
      )}
    </>
  );
};

export default AdminUserRegister;
